import { render, staticRenderFns } from "./TicketTable.pug?vue&type=template&id=136a1122&scoped=true&lang=pug&"
import script from "./TicketTable.vue?vue&type=script&lang=js&"
export * from "./TicketTable.vue?vue&type=script&lang=js&"
import style0 from "./TicketTable.scss?vue&type=style&index=0&id=136a1122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a1122",
  null
  
)

export default component.exports